/** Codegen bookkeeping for Beginner Time blocks. */

let everyBlockCounter = 0;
const everyBlockIndexes = new Map<string, number>();

export function resetBeginnerTimeCodegenState(): void {
  everyBlockCounter = 0;
  everyBlockIndexes.clear();
}

/** Stable simple index for each `every` block within one sketch generation. */
export function getEveryBlockIndex(blockId: string): number {
  const existing = everyBlockIndexes.get(blockId);
  if (existing != null) {
    return existing;
  }
  everyBlockCounter += 1;
  everyBlockIndexes.set(blockId, everyBlockCounter);
  return everyBlockCounter;
}
